
import moment from "moment";
import { computed, defineComponent, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "user-approve-modal",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD YYYY, h:mm a");
    },
  },
  setup() {
    const store = useStore();

    const loading = ref<boolean>(false);
    const approveButton = ref<HTMLElement | null>(null);
    const rejectButton = ref<HTMLElement | null>(null);

    const currentUserEdit = computed(() => {
      return store.getters.currentUserEdit;
    });

    const reject = (user) => {
      Swal.fire({
        html: `Are you sure to reject?`,
        icon: "warning",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Reject it!",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-light",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (rejectButton.value) {
            // Activate indicator
            rejectButton.value.setAttribute("data-kt-indicator", "on");
          }
          store
            .dispatch(Actions.ADMIN_APPROVE_USER, {
              userId: user.idUser,
              isApproved: false,
            })
            .then(() => {
              rejectButton.value?.removeAttribute("data-kt-indicator");

              Swal.fire({
                text: store.getters.getAdminMessage,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                window.location.reload();
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.getAdminMessage,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    };

    const approve = (user) => {
      if (approveButton.value) {
        // Activate indicator
        approveButton.value.setAttribute("data-kt-indicator", "on");
      }

      store
        .dispatch(Actions.ADMIN_APPROVE_USER, {
          userId: user.idUser,
          isApproved: true,
        })
        .then(() => {
          approveButton.value?.removeAttribute("data-kt-indicator");

          Swal.fire({
            text: store.getters.getAdminMessage,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch(() => {
          Swal.fire({
            text: store.getters.getAdminMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
        });
    };

    watchEffect(() => {
      const data = store.getters.currentUserEdit;
      if (data === null) return;
      console.log("watch effect");
      console.log(data);
    });

    return {
      currentUserEdit,
      loading,
      reject,
      approve,
      approveButton,
      rejectButton,
    };
  },
});
